import { Center, Heading, Box } from "@chakra-ui/react";
import "../styles/app.css";
import {useNavigate} from "react-router-dom";

export default function App() {
    const navigate = useNavigate();

    return (
        <div className={"app"}>
            <Center h="100vh">
                <Box display="flex" flexDirection="column" alignItems="center">
                    <Heading as="h1" size="2xl" className={"text"}>
                        C'est l'heure de jouer 🎮
                    </Heading>
                    <button className={"button-glow"} onClick={() => {
                        navigate("/register");
                    }}>
                        Commençons
                    </button>
                </Box>
            </Center>
        </div>
    );
}
